import React from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
class Pagination extends AbstractComponent {     
    onClick(item) {
        if(this.props.page === item) {
            return ;
        }

        this.props.onPreload(true);

        this.props.filterService(
            this.props.filter,
            item
        ).then(resposta => {
            this.props.onCallback(item, resposta, undefined);            
            this.props.onPreload(false);
        }).catch(erro => {
            this.props.onCallback(item, undefined, erro);            
            this.props.onPreload(false);
        });
    }          

    render() {
        return (
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg} 
                className={(document.documentElement.clientWidth > 767 ? "text-right" : "text-center")}
            >                           
                <nav aria-label="Page navigation example">
                    <ul className="pagination">
                        <li className="page-item">
                            <a 
                                className="page-link" 
                                arial-label="Anterior" 
                                style={{pointerEvents: (this.props.page - 1 === 0 ? 'none' : 'all')}}
                                onClick={() => this.onClick(this.props.page - 1)}
                            >
                                <span aria-hidden="true">
                                    &laquo; 
                                </span>

                                <span className="sr-only">
                                    Anterior
                                </span>
                            </a>
                        </li>

                        {
                            this.props.pagination.map((item, index) => {
                                return (
                                    <li key={index} className={"page-item " + (this.props.page === item ? 'active' : '')}>
                                        <a className="page-link" onClick={() => this.onClick(item)}>
                                            { item }
                                        </a>
                                    </li>
                                )
                            })
                        }    

                        <li className="page-item">
                            <a 
                                className="page-link" 
                                arial-label="Próximo"                                 
                                style={{pointerEvents: (this.props.page + 1 > this.props.pagination.length ? 'none' : 'all')}}
                                onClick={() => this.onClick(this.props.page + 1)}
                            >
                                <span aria-hidden="true">
                                    &raquo;
                                </span>

                                <span className="sr-only">
                                    Próximo
                                </span>
                            </a>
                        </li>                                        
                    </ul>
                </nav>                
            </Col>
        )
    }
}

export default Pagination;